import { MODE_CONTACT } from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import {
  buildContactWizardSteps,
  shouldShowWhoReceivingCareSection,
} from 'client-portal/utils/contact/wizard-steps';
import { cached, tracked } from '@glimmer/tracking';
import QuestionProcessor from 'client-portal/utils/prescreener/question-processor';
import Service, { service } from '@ember/service';

export default class ContactStepsService extends Service {
  @service currentPractice;
  @service prescreener;

  @tracked currentIndex = 0;

  @cached
  get steps() {
    const isEnabled = this.prescreener.isContactFormEnabled;
    const questions = this.prescreener.questions;

    return buildContactWizardSteps({
      isEnabled,
      showWhoReceivingCareSection: shouldShowWhoReceivingCareSection(this.currentPractice),
      visibleCategories:
        isEnabled && questions
          ? new QuestionProcessor({
              prescreener: this.prescreener,
              formType: MODE_CONTACT,
            }).categories
          : [],
    });
  }

  get activeIndex() {
    const { length } = this.steps;
    if (length === 0) {
      return 0;
    }

    return Math.min(this.currentIndex, length - 1);
  }

  get currentStep() {
    return this.steps[this.activeIndex];
  }

  get isFirst() {
    return this.activeIndex === 0;
  }

  get isLast() {
    return this.steps.length === 0 || this.activeIndex === this.steps.length - 1;
  }

  get isEnabled() {
    return this.steps.length > 0;
  }

  reset() {
    this.currentIndex = 0;
  }

  @action
  goNext() {
    if (this.isLast) {
      return;
    }

    this.currentIndex = this.activeIndex + 1;
  }

  @action
  goBack() {
    if (this.isFirst) {
      return;
    }

    this.prescreener.validation.resetValidation();
    this.currentIndex = this.activeIndex - 1;
  }
}
